<template>
    <div>
        <van-nav-bar
                title="网站栏目"
                left-text="返回"
                right-text="添加栏目"
                left-arrow
                @click-left="onClickLeft" @click-right="onClickRight"
        />
        <van-cell-group>
            <van-cell :title="nav.title" value="内容" v-for="(nav,index) in list" :key="index" >
                <span @click="clickEdit(nav.nav_id)"><van-icon name="edit" /> 编辑</span><span class="blank-line" @click="clickDelete(nav.nav_id)"><van-icon name="delete" /> 删除</span>

            </van-cell>
        </van-cell-group>
    </div>
</template>

<script>
    import {NavBar,Cell,CellGroup,Icon,Dialog} from 'vant'
    import Cookies from 'js-cookie'
    export default {
        name: "index",
        components:{
            [NavBar.name]:NavBar,
            [Cell.name]:Cell,
            [CellGroup.name]:CellGroup,
            [Icon.name]:Icon,
            [Dialog.name]:Dialog
        },
        data(){
            return {
                list:[]
            }
        },
        created() {
            this.$http.get(this.apiUrl+'/v1/nav/index',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
                this.list = data.result;
            })
        },
        methods:{
            onClickLeft(){
                this.$router.back();
            },
            onClickRight(){
                this.$router.push('/mobile/nav/edit')
            },
            clickEdit(navId){
                this.$router.push('/mobile/nav/edit?id='+navId)
            },
            clickDelete(navId){
                this.$http.delete(this.apiUrl+'/v1/nav/delete',{params:{navId:navId}}).then(({data})=>{
                    Dialog.alert({
                        message:data.msg
                    }).then(()=>{
                        this.$http.get(this.apiUrl+'/v1/nav/index').then(({data})=>{
                            this.list = data.result;
                        })
                    })
                })
            }
        }
    }
</script>

<style scoped>
    .blank-line{
        margin:0 0 0 10px;
    }
</style>
